import Flickity from 'flickity';

function TeamCarousel(el) {
  let flickity = null;
  const carousel = el.querySelector('.team-carousel');

  function getFlickity() {
    if (!flickity) {
      flickity = new Flickity(carousel, {
        cellSelector: '.team-carousel__cell',
        cellAlign: 'left',
        wrapAround: true,
        lazyLoad: true,
        adaptiveHeight: true,
      });

      flickity.viewport.style.overflow = 'visible';
      flickity.resize();
    }

    return flickity;
  }

  function init() {
    getFlickity();
  }

  init();
}

export default TeamCarousel;
